import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask';

import { DialogService } from 'primeng/dynamicdialog';
import { TooltipModule } from 'primeng/tooltip';

import { SharedModule } from 'app/modules/shared/shared.module';
import { DataService, HTTPService } from 'app/services';

import { CustomerAppointMentRequestRoutingModule } from './customer-appointment-request.routing';
import { CustomerAppointmentRequestComponent } from './components/customer-appointment-request/customer-appointment-request.component';
import { GoogleAppointmentRequestComponent } from './components/google-appointment-request/google-appointment-request.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie';
import { CustomTranslateLoader } from 'app/services/custom-translate-loader';
import { PrivacyPolicyTemplateComponent } from './components/privacy-policy-template/privacy-policy-template.component';
@NgModule({
  imports: [CommonModule, FormsModule, CustomerAppointMentRequestRoutingModule, HttpClientModule, LoadingBarHttpClientModule, SharedModule, TooltipModule, NgxMaskDirective, NgxMaskPipe, TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useClass: CustomTranslateLoader,
      deps: [HttpClient, CookieService, DataService, HTTPService]
    }
  })],
  declarations: [CustomerAppointmentRequestComponent, GoogleAppointmentRequestComponent, PrivacyPolicyTemplateComponent],
  providers: [HTTPService, DialogService],
})
export class CustomerAppointmentRequestModule { }
